import { Flex, Text } from '@mantine/core';
import { useMemo } from 'react';
import { OverflowBadge } from '@dealstack/frontend/app/pages/Valuations/components/OverflowBadgeList/OverflowBadge';

type MipRef = { id: string; programmeName: string | null };

const DRAFT_MIP_LABEL = 'Draft MIP';

const displayName = (mip: MipRef) => mip.programmeName ?? DRAFT_MIP_LABEL;

export const MipCell = ({ mips }: { mips: MipRef[] }) => {
	const sorted = useMemo(
		() => [...(mips ?? [])].sort((a, b) => displayName(a).localeCompare(displayName(b))),
		[mips]
	);

	if (sorted.length === 0) {
		return <Text>—</Text>;
	}

	const [first, ...rest] = sorted;

	if (rest.length === 0) {
		return <Text>{displayName(first)}</Text>;
	}

	return (
		<Flex align="center" gap="0.25rem">
			<Text>{displayName(first)}</Text>
			<OverflowBadge badge={{ id: 'mip-overflow', label: `+${rest.length}` }} />
		</Flex>
	);
};
